
import firebase from "firebase/compat/app";
import "firebase/compat/auth";
import "firebase/compat/firestore";
import "firebase/compat/storage";
import "firebase/compat/functions";

// --- FIREBASE CONFIGURATION ---
// Restored from stable version (target: kevin-erp-demo)
const firebaseConfig = {
  apiKey: "AIzaSyBRfaic-kj8Ua0Z3niAoR1zazkUCjLCDnA",
  authDomain: "kevin-erp-demo.firebaseapp.com",
  projectId: "kevin-erp-demo",
  storageBucket: "kevin-erp-demo.firebasestorage.app",
  messagingSenderId: "889617498860",
  appId: "1:889617498860:web:a59227f8892c3c89a6dbc9"
};

// Initialize only once
const app = !firebase.apps.length ? firebase.initializeApp(firebaseConfig) : firebase.app();

export const auth = firebase.auth();
export const db = firebase.firestore();
export const storage = firebase.storage();
export const functions = firebase.app().functions("asia-east1");
export const serverTimestamp = firebase.firestore.FieldValue.serverTimestamp;

export { firebase };
export default firebase;
